import { i18n } from 'i18next'

const i18nInstances: i18n[] = []

export const registerI18nInstance = (instance: i18n) => {
  i18nInstances.push(instance)
}

export const changeAllLanguages = async (newLang: string) => {
  await Promise.all(
    i18nInstances.map((instance) => instance.changeLanguage(newLang))
  )
}
